import "./styles/style.less";
import { CategoriesLister } from "./app/CategoriesLister";
import { CategoryItemsLister } from "./app/CategoryItemsLister";
import { GlobalEventBus } from "./app/events/GlobalEventBus";
import { EventTypes } from "./app/events/EventTypes";
import { MenuItemImage } from "./app/editor/MenuItemImage";
import { LoadingState } from "./app/editor/LoadingState";
import { AlphaVideoPlayer } from "./app/videoplayer/player/AlphaVideoPlayer";
import { WixComms } from "./app/wix-comms/WixComms";
import { WixCart } from "./app/wix-comms/WixCart";
import { IBoundingBox } from "./app/videoplayer/model/IBoundingBox";
import { Config } from "./app/config/Config";
import { ProductMapper } from "./app/products/ProductMapper";
import { IProductMap } from "./app/products/IProductMap";
import { Choice, Color, Item } from "../src/wix-api/typedefs/IWixItemsInCollection";

const loadingState: LoadingState = new LoadingState();

const catRoot: HTMLDivElement = document.querySelector('#bagselector') as HTMLDivElement;
const addToCart: HTMLDivElement = document.querySelector('#addtocart') as HTMLDivElement;
const priceDiv: HTMLDivElement = document.querySelector('#price') as HTMLDivElement;
const descDiv: HTMLDivElement = document.querySelector('#description') as HTMLDivElement;
const colorRoot: HTMLDivElement = document.querySelector('#colorselector') as HTMLDivElement;
const loadingPercent: HTMLDivElement = document.querySelector('#loadingpercent') as HTMLDivElement;
const bagVideoCanvas: HTMLCanvasElement = document.getElementById('bagvideocanvas') as HTMLCanvasElement;
const allcoloursinfo: HTMLDivElement = document.getElementById('allcoloursinfo') as HTMLDivElement;
const infoboxDiv: HTMLDivElement = document.getElementById('infobox') as HTMLDivElement;
const infobutton: HTMLDivElement = document.getElementById('infobutton') as HTMLDivElement;
const infoBoxClose: HTMLDivElement = document.getElementById('infoBoxClose') as HTMLDivElement;
const infoBoxTitle: HTMLDivElement = document.getElementById('infoBoxTitle') as HTMLDivElement;

const categoriesLister: CategoriesLister = new CategoriesLister();
const itemsLister: CategoryItemsLister = new CategoryItemsLister();

const productMapper: ProductMapper = new ProductMapper();

const bagVideoPlayer: AlphaVideoPlayer = new AlphaVideoPlayer(bagVideoCanvas);

let currentCategories: MenuItemImage[];
let currentItems: MenuItemImage[];

let selectedBagId: string = '';
let selectedItem: Item | undefined;

const wixComms: WixComms = new WixComms();
const wixCart: WixCart = new WixCart(wixComms);

addToCart.addEventListener("click", ()=>{
  if (selectedItem){
    wixCart.addProductToCart(selectedItem, selectedColorInfo as Choice);
  }
})

function cleanupCurrentItems(){
  while (colorRoot.children.length > 0) {
    colorRoot.removeChild(colorRoot.firstChild as ChildNode);
  }
}

function selectItemClass(){
  const id = `item_${selectedBagId}`;
  console.log('selectItemClass', id, document.getElementById(id));
  for (let i=0; i<colorRoot.children.length; i++) {
    colorRoot.children.item(i)?.classList.remove('selected');
  }
  document.getElementById(id)?.classList.add('selected');
}

function showCategories(){
  const randomStartupCategory = currentCategories[Math.ceil(Math.random()*currentCategories.length-1)];
  currentCategories.forEach(item => {
    const img: HTMLImageElement = item.render();
    catRoot.appendChild(img);
  });
  randomStartupCategory.doClick();
}

function bagUp(){
  bagVideoCanvas.style.top =`-100vh`;
}

function bagDown(){
    bagVideoCanvas.style.top =`0px`;
}

let selectBagTimeout: any;
let selectedProductMap: IProductMap | undefined;
let selectedColorInfo: Choice | undefined;

async function selectBag(id: string, videoName: string, colorInfo: Choice) {
  console.log('Selected Bag ID',id);
  console.log('selectedColorInfo',colorInfo);
  if (selectBagTimeout) {
    clearTimeout(selectBagTimeout);
    selectBagTimeout = null;
  }
  selectedProductMap = productMapper.getProductMapById(id);
  selectedColorInfo = colorInfo;
  bagUp();
  selectedBagId = id;
  selectedItem = itemsLister.getItemById(selectedBagId);
  console.log('selectedItem', selectedItem);
  priceDiv.innerHTML = `${selectedItem?.price}€`;
  descDiv.innerHTML = `${String(selectedItem?.name)} <i>${colorInfo.description}</i>`;
  selectBagTimeout = setTimeout(async ()=>{
    selectItemClass();
    bagVideoPlayer.clear();
    await bagVideoPlayer.loadFiles(videoName);
    bagVideoPlayer.start();
    selectBagTimeout = null;
  }, 1000);
}

function closeInfoBox() {
  infoboxDiv.style.top = '';
  infoboxDiv.style.left = '';
  infoboxDiv.style.right = '';
  infoboxDiv.style.bottom = '';
  infoboxDiv.style.borderRadius = '';
  infoboxDiv.style.padding ='0';
  infoboxDiv.querySelector('#infoboxContent')!.innerHTML = '';
  infoBoxClose.style.opacity = '0';
}

function growInfoBox(){
  infoboxDiv.style.top = '5%';
  infoboxDiv.style.left = '5%';
  infoboxDiv.style.right = '5%';
  infoboxDiv.style.bottom = '5%';
  infoboxDiv.style.borderRadius = '2vh';
  infoboxDiv.style.padding ='2vh';
  infoBoxClose.style.opacity = '1';
  infoboxDiv.querySelector('#infoboxContent')!.innerHTML = selectedItem?.description!;
  infoBoxTitle.innerText = selectedItem?.name!;
}

function showItems(){
  cleanupCurrentItems();
  currentItems.forEach(item => {
    const img: HTMLImageElement = item.render();
    console.log(img);
    colorRoot.appendChild(img);
  });
  let randomItem;
  let retries = 0;
  while (!randomItem && retries++ < 10) {
    randomItem = currentItems[Math.ceil(Math.random()*currentItems.length-2)];
  }
  if(randomItem){
    randomItem.doClick();
  }
}

async function start (){
  await productMapper.fetchProducts();
  currentCategories = await categoriesLister.getCategories();
  wixComms.sendMessage('STARTUP TEST');
  showCategories();
}

async function showCategory(id: string) {
  cleanupCurrentItems();
  currentItems = await itemsLister.getItems(id);
  showItems();
}

GlobalEventBus.addEventListener(EventTypes.MENU_ITEM_CLICKED, async (ev: any)=>{
  console.log(ev.eventData);
  if(ev.eventData.id === 'item_rainbow') {
    allcoloursinfo.style.visibility = 'visible';
  } else {
    allcoloursinfo.style.visibility = 'hidden';
    const eventDataParts: string[] = ev.eventData.id.split('_');
    const clickType: string = eventDataParts[0];
    const clickId: string = eventDataParts[1];
    if (clickType === 'category'){
      await showCategory(clickId);
    } else if (clickType === 'item') {
      selectBag(clickId, ev.eventData.videoURL, ev.eventData.colorInfo);
    }
  }
});

GlobalEventBus.addEventListener(EventTypes.BAG_VIDEO_LOADING, async (ev: any)=> {
  console.log('loading');
  loadingState.setLoading();
  loadingPercent.innerHTML = `Loading...`;
});

GlobalEventBus.addEventListener(EventTypes.VIDEO_LOAD_PROGRESS, async (ev:any) => {
  const { loaded, total } = ev.eventData;
  const percentage = Math.ceil ((loaded / total)*100);
  loadingPercent.innerHTML = `${percentage}%`;
});

GlobalEventBus.addEventListener(EventTypes.BAG_VIDEO_LOADED, async (ev: any)=> {
  console.log('bag loaded');
  setTimeout(()=>{
    bagDown();
  },1000);
  loadingState.siteLoaded();
  loadingState.hideLoading();
  infobutton.addEventListener('click', ()=>{
    growInfoBox();
  });
  infoBoxClose.addEventListener('click', ()=>{
    closeInfoBox();
  });
});

GlobalEventBus.addEventListener(EventTypes.VIDEO_BOUNDING_BOX_CHANGE, (ev:any) => {
  const bb: IBoundingBox = ev.eventData as IBoundingBox;
  const availableHeight: number = window.innerHeight * 0.8;
  const availableWidth: number = window.innerWidth;
  const scaleFactorH: number = availableHeight / bb.bottom;
  bagVideoCanvas.style.height = `${String(bagVideoCanvas.height * scaleFactorH)}px`;
  //const zoom = -5 + Math.sin(new Date().getMilliseconds()/ 5000) * 10;
 // bagVideoCanvas.style.transform = `rotateX(${zoom*0.2}deg) rotateY(${zoom*0.1}deg) translateZ(${zoom*10}px)`;
  const bcr = bagVideoCanvas.getBoundingClientRect();
  bagVideoCanvas.style.left = `${String((availableWidth - bcr.width) / 2)}px`;
  //bagVideoCanvas.style.top = `${String(-bb.y * scaleFactorH)}px`;
});


let usingDeviceRotation: boolean = false;
if (Config.IS_MOBILE) {
  GlobalEventBus.addEventListener(EventTypes.PHONE_ROTATED, (ev: any)=>{
    if (bagVideoPlayer?.rendered) {
      bagVideoPlayer.currentFrame = Math.floor(bagVideoPlayer.totalFrames * ev.eventData );
      if (!usingDeviceRotation) {
        //TODO
        usingDeviceRotation = true;
      }
    }
  });
} else {
  document.addEventListener('mousemove', (e)=>{
    const pos = (e.pageX / window.innerWidth);
    if (bagVideoPlayer?.rendered) {
      bagVideoPlayer.currentFrame = Math.floor(bagVideoPlayer.totalFrames * pos);
    }
  })
}

start();
